export const coreURI = "https://ev-api.adler.ai";
export const evotingIntrospectionQueryResultData = {
  __schema: {
    types: [
      {
        kind: "UNION",
        name: "companyOrcompanyId",
        possibleTypes: [{ name: "Company" }, { name: "CompanyId" }],
      },
      {
        kind: "UNION",
        name: "scrutinizerOrscrutinizerId",
        possibleTypes: [{ name: "User" }, { name: "UserId" }],
      },
    ],
  },
};
